<template>
  <div>
    <component :is="formComponent" v-if="!wasteResult" @waste-saved="onWasteSaved" />
    <waste-result-display
      v-else
      :total-weight-kg="wasteResult.total_weight_kg"
      :categories="wasteResult.categories"
      :before-yesterday-weight-kg="wasteResult.before_yesterday_weight_kg"
      :initial-mode="wasteResult.displayMode"
      :today-saved="todaySaved"
      :meal-date="mealDate"
      @back="wasteResult = null"
    />
  </div>
</template>

<script>
import WasteVisualization from "@/components/WasteVisualization.vue"
import WasteVisualizationSimple from "@/components/WasteVisualizationSimple.vue"
import WasteVisualizationMedium from "@/components/WasteVisualizationMedium.vue"
import WasteResultDisplay from "@/components/WasteResultDisplay.vue"

export default {
  name: "WasteInputPanel",
  components: {
    WasteVisualization,
    WasteVisualizationSimple,
    WasteVisualizationMedium,
    WasteResultDisplay,
  },
  props: {
    canteenId: {
      type: Number,
      default: null,
    },
    variant: {
      type: String,
      default: "barquette",
      validator: (v) => ["barquette", "simple", "medium"].includes(v),
    },
    mealDate: {
      type: String,
      default: null,
    },
    serviceId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      wasteResult: null,
      todaySaved: false,
    }
  },
  computed: {
    formComponent() {
      if (this.variant === "simple") return "WasteVisualizationSimple"
      if (this.variant === "medium") return "WasteVisualizationMedium"
      return "WasteVisualization"
    },
  },
  watch: {
    mealDate: "loadPanel",
    serviceId: "loadPanel",
    canteenId: "loadPanel",
  },
  mounted() {
    if (this.canteenId && this.mealDate) {
      this.loadPanel()
    }
  },
  methods: {
    loadPanel() {
      if (!this.canteenId || !this.mealDate) return

      // Affiche toujours J-1, pas J
      const prevDate = this._previousDateOf(this.mealDate)
      const params = new URLSearchParams({ date: prevDate })
      if (this.serviceId) params.append("service_id", this.serviceId)

      this.$store
        .dispatch("fetchWasteMeasurementsForDate", {
          canteenId: this.canteenId,
          params: params.toString(),
        })
        .then((measurements) => {
          if (measurements && measurements.length > 0) {
            const m = measurements[0]
            this.wasteResult = {
              total_weight_kg: parseFloat(m.totalWeightKg),
              categories: m.categories || [],
              displayMode: "display",
              before_yesterday_weight_kg: null,
            }
            this._fetchJ2(prevDate)
          } else {
            // Pas de mesure J-1 → formulaire de saisie
            this.wasteResult = null
          }
        })
        .catch(() => {
          this.wasteResult = null
        })

      // Vérifier si la saisie du jour (J) a déjà été réalisée
      const todayParams = new URLSearchParams({ date: this.mealDate })
      if (this.serviceId) todayParams.append("service_id", this.serviceId)
      this.$store
        .dispatch("fetchWasteMeasurementsForDate", {
          canteenId: this.canteenId,
          params: todayParams.toString(),
        })
        .then((m) => {
          this.todaySaved = !!(m && m.length > 0)
        })
        .catch(() => {
          this.todaySaved = false
        })
    },

    _previousDateOf(dateStr) {
      const d = new Date(dateStr)
      d.setDate(d.getDate() - 1)
      return d.toISOString().split("T")[0]
    },

    _fetchJ2(j1DateStr) {
      const j2Date = this._previousDateOf(j1DateStr)
      const params = new URLSearchParams({ date: j2Date })
      if (this.serviceId) params.append("service_id", this.serviceId)

      this.$store
        .dispatch("fetchWasteMeasurementsForDate", {
          canteenId: this.canteenId,
          params: params.toString(),
        })
        .then((measurements) => {
          if (this.wasteResult) {
            const j2 = measurements && measurements.length > 0 ? measurements[0] : null
            this.wasteResult = {
              ...this.wasteResult,
              before_yesterday_weight_kg: j2 ? parseFloat(j2.totalWeightKg) : null,
            }
          }
        })
        .catch(() => {})
    },

    onWasteSaved(data) {
      if (!this.canteenId) {
        this.wasteResult = data
        return
      }

      const mealDate = this.mealDate || new Date().toISOString().split("T")[0]
      const payload = {
        measurement_type: data.type,
        total_weight_kg: data.total_weight_kg,
        categories: data.categories || [],
        meal_date: mealDate,
        notes: "",
      }
      if (this.serviceId) payload.service = this.serviceId

      this.$store
        .dispatch("saveWasteMeasurement", { canteenId: this.canteenId, payload })
        .then(() => {
          this.todaySaved = true
          // Après sauvegarde de J, on affiche J-1
          this.loadPanel()
        })
        .catch(() => {
          this.wasteResult = null
        })
    },
  },
}
</script>
